import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
/**
 * Link component for auth form footers
 * Used for "Already have an account?", "Forgot password?", etc.
 */
export const AuthFooterLink = ({ className, href, onClick, children, }) => {
    const commonProps = {
        className: clsx('auth-footer-link', className),
    };
    if (href) {
        return (_jsx("a", { ...commonProps, href: href, children: children }));
    }
    return (_jsx("button", { ...commonProps, type: "button", onClick: onClick, children: children }));
};
AuthFooterLink.displayName = 'AuthFooterLink';
//# sourceMappingURL=AuthFooterLink.js.map